import { render, staticRenderFns } from "./AccumulationSelling.vue?vue&type=template&id=38443078&scoped=true"
import script from "./AccumulationSelling.vue?vue&type=script&lang=js"
export * from "./AccumulationSelling.vue?vue&type=script&lang=js"
import style0 from "./AccumulationSelling.vue?vue&type=style&index=0&id=38443078&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38443078",
  null
  
)

export default component.exports